<template>
  <div
    class="pt-5 container-fluid scrollbar"
    id="style-4"
    style="position:sticky; margin-top: 85px"
  >
    <div style="margin-top:-20px">
      <h1
        class="heading"
        style="color: #F69325; text-shadow: 0.5px 0.5px  2px #F69325"
      >
        My Shopping Cart
      </h1>
      <div class="row pt-2 text-color">
        <div
          class="col-sm-12 mb-2"
          style="display:flex; justify-content: space-between"
        >
          <div>
            <i class="fa fa-shopping-cart fa-lg"></i>
            <span style="font-size:20px; font-weight:bold">
              {{ carts.length }}</span
            >
            items
          </div>
          <div>
            ₹
            <span style="font-size:20px; font-weight:bold">{{
              getCartTotalPrice()
            }}</span>
          </div>
        </div>
      </div>
      <div class="row pt-3 pb-3 text-center">
        <b-button
          class="btn btn-success btn-custom"
          :disabled="carts.length == 0"
          :to="'/CheckOut'"
        >
          <span class="pt-3">
            Proceed to Checkout
          </span>
        </b-button>
      </div>
      <a style="margin-left:-8px"
        >Continue Shopping <i class="fa fa-caret-right"></i
      ></a>
      <!-- image -->
      <div class="row">
        <div v-for="cartPro in carts" :key="cartPro.createdAt">
          <div class="mt-2" style="background-color: #fff;">
            <div class="row">
              <div class="col-sm-6" style="margin:0; padding:0">
                <img
                  :src="getProduct(cartPro.productId, 'image')"
                  width="100%"
                  height="100%"
                  style="border-right: 3px solid #F2F2F2; height: 100%;"
                />
              </div>
              <div class="col-sm-6 pl-1 text-center">
                <span class="product-name text-color">{{
                  getProduct(cartPro.productId, "name")
                }}</span>

                <p class="product-price pt-2">
                  ₹
                  {{ cartPro.price }}
                </p>
                <br />
                <hr style="margin:16px 10px 10px 0px" />
                <div>
                  <span class="cart-add">
                    <i
                      class="btn btn-sm btn-circle fa fa-minus"
                      style="background-color:#D0D0D2; color:#1A1824; width:10px; height:20px"
                      @click="
                        addToCart(
                          cartPro.vendorProductId,
                          cartPro.productId,
                          cartPro.qty,
                          getProduct(cartPro.productId, 'unitType'),
                          getVendorProduct(
                            cartPro.vendorProductId,
                            'sellprice'
                          ),
                          'minus',
                          user.uid,
                          cartPro.vendorId
                        )
                      "
                    ></i>
                    <span style="padding:5px;">
                      {{ cartPro.qty }}
                      {{ getProduct(cartPro.productId, "unitType") }}
                    </span>
                    <i
                      class="btn btn-sm btn-circle fa fa-plus"
                      style="background-color:#51381b ; color:#FFFFFF; width:10px; height:20px"
                      @click="
                        addToCart(
                          cartPro.vendorProductId,
                          cartPro.productId,
                          cartPro.qty,
                          getProduct(cartPro.productId, 'unitType'),
                          getVendorProduct(
                            cartPro.vendorProductId,
                            'sellprice'
                          ),
                          'plus',
                          user.uid,
                          cartPro.vendorId
                        )
                      "
                    ></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db, dbFs } from "@/modules/database";
import { mapGetters, mapActions } from "vuex";
import { addToCart } from "@/modules/cart";
export default {
  data() {
    return {
      loading: false,
      cart_count: 5,
      cart: [],
      cart_unit: "kg",
      cart_total: 22.22 * 5,
      carts: [],
      products: [],
      vendorProducts: []
    };
  },
  mounted() {
    this.setupFirebaseReading();
    this.srn = 1;
  },
  methods: {
    setupFirebaseReading() {
      this.loading = true;
      if (this.user) {
        this.$rtdbBind("carts", db.ref("carts/" + this.user.uid))
          .then(() => {
            this.loading = false;
            this.getProducts();
            this.getVendorProducts();
            this.addCart(this.carts);
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
            this.loadingError = true;
          });
      }
    },
    getProducts() {
      this.$bind("products", dbFs.collection("products"))
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getVendorProducts() {
      this.$bind(
        "vendorProducts",
        dbFs.collection("vendorProducts").where("status", "==", true)
      )
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProduct(id, dataType) {
      let productDetails = "";
      for (const cusKey of Object.keys(this.products)) {
        const product = this.products[cusKey];
        if (id == product.id) {
          productDetails = product;
        }
      }
      if (dataType == "name") {
        return productDetails.name;
      }
      if (dataType == "unitType") {
        return productDetails.unitType;
      }
      if (dataType == "image") {
        return productDetails.image;
      }
    },
    getVendorProduct(id, dataType) {
      let productDetails = "";
      for (const cusKey of Object.keys(this.vendorProducts)) {
        const product = this.vendorProducts[cusKey];
        if (id == product.id) {
          productDetails = product;
        }
      }
      if (dataType == "sellprice") {
        return productDetails.sellPrice;
      }
      if (dataType == "stock") {
        return productDetails.stock;
      }
      if (dataType == "moq") {
        return productDetails.moq;
      }
    },
    getCartTotalPrice() {
      let total = 0;
      this.carts.forEach(cart => {
        total += cart.price;
      });

      return total;
    },
    addToCart
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    }),
    ...mapActions({
      addCart: "addCart"
    })
  },
  watch: {
    user() {
      this.setupFirebaseReading();
    }
  }
};
</script>

<style scoped>
.btn-success {
  background-color: #51381b;
  border-color: #51381b;
}
.product-name {
  font-size: 0.9rem;
  font-weight: bold;
}
.line {
  height: 1px;
  margin: auto;
  width: 60px;
  background-color: #51381b;
}
.product-price {
  margin-bottom: -30px;
  color: #f69325;
  font-size: 1vw;
  font-weight: bold;
}
.btn-custom {
  width: 220px;
  border-radius: 25px;
  height: 50px;
  padding-top: 12px;
  background-color: #489b29;
  border: none;
  color: rgb(245, 245, 245);
}
.heading {
  font-size: 1.4vw;
  font-weight: bold;
  letter-spacing: -0.22px;
}
.text-color {
  color: #2b2b2b;
}

.scrollbar {
  height: 380vh;
  background: #f5f5f5;
  overflow-y: scroll;
  margin-bottom: 25px;
}
.force-overflow {
  min-height: 450px;
}

#style-4::-webkit-scrollbar-track {
  background-color: #f5f5f5;
}

#style-4::-webkit-scrollbar {
  width: 5px;
  background-color: #f5f5f5;
}

#style-4::-webkit-scrollbar-thumb {
  background-color: #9a9c9b;
}
</style>
